import { WorkflowStepCode } from '@exam-management/graphql';
import { Tab, TabContext, TabList } from '@shared/components';

import { useQuestionReviewTaskSearchParams } from '../../hooks';

const TAB_LIST = [
  {
    value: '',
    label: 'All',
  },
  {
    value: WorkflowStepCode.QuestionReviewTodo,
    label: 'Todo',
  },
  {
    value: WorkflowStepCode.QuestionReviewInReview,
    label: 'In Review',
  },
  {
    value: WorkflowStepCode.QuestionReviewReviewed,
    label: 'Reviewed',
  },
  {
    value: WorkflowStepCode.QuestionReviewDone,
    label: 'Done',
  },
];

export default function QuestionReviewStatusFilter() {
  const [{ code }, setSearchParams] = useQuestionReviewTaskSearchParams();

  const handleClick = (value: WorkflowStepCode | '') => {
    setSearchParams({
      code: value,
      page: 0,
    });
  };

  return (
    <TabContext value={code ?? ''}>
      <TabList
        sx={(theme) => ({
          gap: theme.spacing(0),
          '& .MuiTabs-flexContainer': {
            gap: theme.spacing(0),
          },
        })}
      >
        {TAB_LIST.map((tab) => {
          return (
            <Tab
              sx={(theme) => ({
                borderRadius: theme.shape.rounded(0),
                pt: theme.spacing(4),
                px: theme.spacing(4),
                minWidth: 'unset',
              })}
              key={tab.value}
              label={tab.label}
              value={tab.value}
              onClick={() => handleClick(tab.value as WorkflowStepCode)}
            />
          );
        })}
      </TabList>
    </TabContext>
  );
}
